import { render, staticRenderFns } from "./PWTAccount.vue?vue&type=template&id=4a58fa04&scoped=true"
import script from "./PWTAccount.vue?vue&type=script&lang=js"
export * from "./PWTAccount.vue?vue&type=script&lang=js"
import style0 from "./PWTAccount.vue?vue&type=style&index=0&id=4a58fa04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a58fa04",
  null
  
)

export default component.exports